module.exports = __webpack_public_path__ + "img/world-map-xs.f3d090ea.png";